import FormSection from '@/components/Forms/FormSection';
import { Box } from '@palmetto/palmetto-components';

import {
  GeneratorInstallPackageFileCategory,
  InstallationPackagePhotoCategory,
  ProgramType,
  RequirementFlagSettingsType,
} from 'types';

import { PhotosList } from '../Documents/PhotosList';

type InstallPhotosProps = {
  allowArchive?: boolean;
  showCheckboxes: boolean;
  checkboxCategories: GeneratorInstallPackageFileCategory[];
  isPackageEditable?: boolean;
};

export const InstallPhotos = ({
  allowArchive,
  showCheckboxes,
  checkboxCategories,
  isPackageEditable = true,
}: InstallPhotosProps) => {
  return (
    <FormSection
      title="All Installation Documentation"
      description={
        <Box gap="sm" fontSize="xs">
          <Box>
            Upload all documents and photos collected during the new generator installation. These must include the
            Equipment Data Plate, Wide Installation View, Transfer Switch / ATS, Fuel Connection, and Remote
            Monitoring Setup.
          </Box>
        </Box>
      }
    >
      <PhotosList
        title="Uploaded Install Documentation"
        baseCategory={'Install Photos'}
        allowArchive={allowArchive}
        category={InstallationPackagePhotoCategory.generatorInstallationPhotos}
        flagType={RequirementFlagSettingsType.generatorInstallationPhotos}
        showCheckboxes={showCheckboxes}
        checkboxCategories={checkboxCategories}
        programType={ProgramType.generator}
        isPackageEditable={isPackageEditable}
      />
    </FormSection>
  );
};
